// extracted by mini-css-extract-plugin
export default {"cta":"aH-z","disabled":"bH-z"};